const hasPermission = (permission: string, userPermissions?: string[]) => {
  if (!userPermissions) return false;
  return userPermissions.includes(permission);
};

export default {
  hasPermission,
};
